/* 
  聘用信息查询
*/
import request from "@/utils/request";

//获取统计页面参数
export function getParam() {
  return request({
    url: "/markteacher/employInfo/getParam",
    method: "get"
  });
}

//获取评卷聘用信息查询分页列表
export function getEmployInfo(params) {
  return request({
    url: "/markteacher/employInfo/getEmployInfo",
    method: "get",
    params
  });
}

//申请更换
export function applyReplace(data) {
  return request({
    url: "/markteacher/employInfo/applyReplace",
    method: "post",
    data
  });
}
//取消申请 /markteacher/employInfo/cancelApplyReplace

export function cancelApplyReplace(data) {
  return request({
    url: "/markteacher/employInfo/cancelApplyReplace",
    method: "post",
    data
  });
}

//打印聘书
export function printOffer(data) {
  return request({
    // url:window.config.baseUrl4Print+ "/markteacher/employInfo/printOffer",
    url:window.config.baseUrl4Shool+ "/markteacher/employInfo/printOffer",
    method: "post",
    responseType:"blob",
    data
  });
}